<template>
  <div class="contentBox">
    <div>
      <span v-if="pageType == 'download'">{{ $t("forceBind.install") }}</span>
      <span v-if="pageType == 'bind'">{{ $t("forceBind.bind") }}</span>
    </div>
    <span>{{ username }}{{ $t("forceBind.bindPrompt") }}</span>
    <el-divider></el-divider>
    <div v-if="pageType == 'download'" class="serviceBox">
      <div>
        <span>{{ $t("forceBind.downloadPrompt") }}</span>
      </div>
      <div class="mfaDownloadQrCodeBox">
        <div>
          <img
            src="../assets/MFA/authenticator_android.png"
            alt=""
            height="150"
            width="150"
          />
          <span>{{ $t("forceBind.mfaAndroidQrCode") }}</span>
        </div>
        <div>
          <img
            src="../assets/MFA/authenticator_iphone.png"
            alt=""
            height="150"
            width="150"
          />
          <span>{{ $t("forceBind.mfaIosQrCode") }}</span>
        </div>
      </div>
      <div>
        <span>{{ $t("forceBind.nextStepPrompt") }}</span>
      </div>
      <div>
        <el-button type="primary" @click="nextStep()">{{
          $t("button.nextStep")
        }}</el-button>
      </div>
    </div>
    <div v-if="pageType == 'bind'" class="serviceBox">
      <div>
        <span>{{ username }}{{ $t("forceBind.forceBindPrompt") }}</span>
      </div>
      <div>
        <span>{{ $t("forceBind.captchaPrompt") }}</span>
      </div>
      <div class="qrcode" id="qrcode" ref="qrcode"></div>
      <div class="tableBox">
        <el-form @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="code"
              :placeholder="$t('google.mfa')"
              style="width: 70%"
              @keyup.enter.native="googleBind()"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="beforeStep()">{{
              $t("button.beforeStep")
            }}</el-button>
            <el-button type="primary" @click="googleBind()">{{
              $t("forceBind.bind")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      googleSecret: "",
      qrcodeContent: "",
      username: "",
      code: "",
      pageType: "download",
    };
  },
  created() {
    this.username = this.$route.params.username;
  },
  methods: {
    getGoogleQrcodeContent() {
      let submitInfo = {
        username: this.username,
      };
      return new Promise((resolve, reject) => {
        this.$httpList
          .getGoogleQrCodeContent(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              this.googleSecret = res.data.secret;
              this.qrcodeContent = res.data.secretQrCode;

              // 二维码生成
              this.$refs.qrcode.innerHTML = ""; // 清除二维码方法
              new QRCode("qrcode", {
                text: this.qrcodeContent,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    googleBind() {
      if (this.code && this.code.length == 6) {
        let submitInfo = {
          username: this.username,
          secret: this.googleSecret,
          code: this.code,
        };
        return new Promise((resolve, reject) => {
          this.$httpList
            .googleBind(submitInfo)
            .then((res) => {
              if (res.resultCode == 1001) {
                // 绑定成功  重新登录
                this.$notify.success({
                  message: this.$t("google.bindSuccess"),
                });
                sessionStorage.clear();
                // cookies 删除
                this.$actions.setGlobalState({
                  accessToken: "",
                  //commonData修改
                  dataUpdate: false,
                  // 当前用户信息
                  currentUser: "",
                  // 当前用户权限树
                  permissionTree: "",
                  // 获取token报错
                  getTokenError: false,
                  //当前客户
                  currentCustomer: "",
                  //当前门店
                  currentStore: "",
                  //控制菜单  隐藏显示
                  showMenu: true,
                  // 公共客户门店数据
                  commonData: {},
                });

                localStorage.removeItem("loginResponse");
                localStorage.removeItem("userInfo");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");

                // 重定向至登录页面
                let currentUrl = window.location.href;
                let position = currentUrl.indexOf("/#");
                let loginUrl = currentUrl.substring(0, position);
                window.location.href = loginUrl;
                resolve(res);
              }
            })
            .catch((err) => {
              reject(err);
            });
        });
      } else {
        this.$notify.warning({
          message: this.$t("googleLogin.inputBoxPrompt"),
        });
      }
    },
    nextStep() {
      this.pageType = "bind";
      this.getGoogleQrcodeContent();
    },
    beforeStep() {
      this.pageType = "download";
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = ""; // 清除二维码方法
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contentBox {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding: 10%;
  .qrcode {
    height: 200px;
    width: 200px;
    background-color: wheat;
    margin: auto;
  }
  .tableBox {
    margin-top: 20px;
  }
}
.serviceBox {
  div {
    margin-bottom: 30px;
  }
  .mfaDownloadQrCodeBox {
    display: flex;
    justify-content: space-around;
    text-align: center;
    div {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
